var module = angular.module('octopusApp.configuration');

module.directive("eventTable", function () {
  return {
    restrict: 'E',
    replace: true,
    transclude: false,
    scope: {
      events: '=',
    },
    templateUrl: 'areas/configuration/audit/views/event_table.html',
    controller: function($scope, eventFormatter) {
        var vm = this;

        vm.formatDiff = function(diff) {
            if (!diff) {
                return diff;
            }
            var replaced = diff.replace(new RegExp("\r&para;", 'g'), "");
            return replaced;
        };

        vm.showDetails = function (e) {
            if (typeof e.detailsVisible === 'undefined' || e.detailsVisible === null) {
                e.detailsVisible = true;
            } else {
                e.detailsVisible = !e.detailsVisible;
            }
        };

        vm.formatMessageHtml = eventFormatter.format;
    },
    controllerAs: 'vm',
    bindToController: true
  };
});


//////////////////
// WEBPACK FOOTER
// ./app/areas/configuration/audit/directives/event_table.js
// module id = 6556750598290056
// module chunks = 1